import React from 'react';
import { FaLeaf, FaSeedling, FaAnchor } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function CrematedRemains() {


  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[650px]"
        style={{ backgroundImage: "url('images/cremated.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">Cremated Remains</h1>
        </div>
      </div>

   

      {/* Our Dedicated Service Section */}
      <section id="dedicated-service" className="py-16 bg-white text-black px-4">
        <div className="max-w-6xl mx-auto space-y-4">
          <h2 className="font-thin text-center lg:mb-8 text-2xl md:text-4xl ">Our Dedicated Service</h2>
          <p className="text-black text-justify px-2 text-lg font-thin">
            Our dedicated courier service specialises in the transport of cremated remains nationwide, providing a compassionate  solution during difficult times. With the utmost respect and sensitivity, we handle the entire process with unwavering care and attention to detail. Understanding the significance of the entrusted ashes, we take it upon ourselves to look after you and your loved one, ensuring that the journey is seamless and secure. Our team of delivery experts is well-trained and empathetic, always ready to be there for you, offering support and understanding as we safely deliver the precious remains to their final destination. You can trust us to handle this delicate task with the utmost professionalism and respect, providing peace of mind during this emotional journey.
          </p>
          <div className="flex justify-center pt-8">
          <Link to='/contactus'>
               <button className="px-6 py-3 bg-slate-900 text-white font-semibold">
               GET FREE QUOTE
               </button></Link>
          </div>
         
        </div>
      </section>

      {/* Logistics and Sustainability Section */}
      <section id="logistics" className="py-16 bg-white text-black px-4">
  <div className="max-w-6xl mx-auto space-y-8">
    <h2 className="text-2xl md:text-4xl font-thin text-center mb-8">Cremated Remains Transportation Across the UK & Internationally</h2>
    <p className="text-black text-justify p-2 text-lg font-thin">
      At 1UKLogistics, we specialize in the transportation of cremated bodies across the UK and internationally. Our service is dedicated solely to ensuring the safe and dignified transfer of cremated remains to their destination.
    </p>
    <p className="text-black text-justify p-2 text-lg font-thin">
      We do not provide burial services, ash scattering, or any other funeral-related arrangements. Our focus is exclusively on the secure and professional transportation of cremated bodies, whether domestically or abroad.
    </p>
    <p className="text-black text-justify p-2 text-lg font-thin">
      With years of experience in handling sensitive transportation needs, our team follows all necessary legal and regulatory requirements to ensure a smooth and respectful transfer process. Whether you need domestic transport within the UK or international repatriation, we are committed to providing a reliable and compassionate service.
    </p>
  </div>
</section>

    </div>
  );
}

export default CrematedRemains;
